import React from "react";

export default function Copyright(){
    return <div style={{backgroundColor: 'teal', color:'white', padding:'1px', fontSize: '11px', marginTop:'9px'}}>
        Copyright © 2020 Metro Creative Graphics, Inc. All&nbsp;rights&nbsp;reserved.
    </div>
}